<div class="eachway-price-button__container">
    <button class="eachway-price-button" [class.selected]="isToggled" (click)="onEachwayButtonClick($event)">
        {{ messages.common.EachWayAbbr }}
    </button>
</div>
